import type { AxiosResponse } from 'axios'
import { defineStore } from 'pinia'
import { ref } from 'vue'

import type {
    CertificateApprovalDetail,
    CertificateApprovalPaper,
    CertificateApprovalsListResponse,
    UpdateCertificateApprovalPayload
} from '@/api/modules/certificateApprovalsQueries'
import { certificateApprovalsService } from '@/views/Quality/services/certificateApprovalsService'

export const useQualityCertificateApprovalsStore = defineStore('qualityCertificateApprovals', () => {
    const currentApproval = ref<CertificateApprovalDetail | null>(null)
    const papers = ref<CertificateApprovalPaper[]>([])

    async function fetchCertificateApprovals(queryString = ''): Promise<AxiosResponse<CertificateApprovalsListResponse>> {
        return certificateApprovalsService.fetchCertificateApprovals(queryString)
    }

    async function fetchCertificateApproval(approvalId: number | string): Promise<AxiosResponse<CertificateApprovalDetail>> {
        currentApproval.value = null
        const response = await certificateApprovalsService.fetchCertificateApproval(approvalId)
        currentApproval.value = response.data
        return response
    }

    async function updateCertificateApproval(
        approvalId: number | string,
        payload: UpdateCertificateApprovalPayload
    ): Promise<AxiosResponse<CertificateApprovalDetail>> {
        return certificateApprovalsService.updateCertificateApproval(approvalId, payload)
    }

    async function fetchCertificateApprovalPapers(): Promise<void> {
        const response = await certificateApprovalsService.fetchCertificateApprovalPapers()
        papers.value = response.data.results.map(({ id, name }) => ({ id, name }))
    }

    return {
        currentApproval,
        papers,
        fetchCertificateApprovals,
        fetchCertificateApproval,
        updateCertificateApproval,
        fetchCertificateApprovalPapers
    }
})
